import { eSigningMethod } from '../../../../types/signingAppointment/eSigningMethod';

const methodsWithoutRate: Set<string> = new Set([
  eSigningMethod.eSign,
  eSigningMethod.thirdPartyNotary,
  eSigningMethod.wetSign,
]);

// useful in some conditional rendering
export const showRate = (selectedSigningMethod?: string, isSignatureSyncAppointment?: boolean): boolean => {
  if (isSignatureSyncAppointment) {
    return false;
  }
  return !methodsWithoutRate.has(selectedSigningMethod ?? '');
};
